import {Button, Stack, Typography} from '@mui/material';
import {FC} from 'react';
import editIcon from '../../../../../../../assets/edit.svg';
import copyIcon from '../../../../../../../assets/copy.svg';
import deleteIcon from '../../../../../../../assets/delete.svg';
import {STYLES} from './styles';

export const Settings: FC = () => {
  return (
    <Stack direction="row" alignItems="center" justifyContent="space-between" sx={STYLES.settings}>
      <Typography sx={STYLES.title}>Настройка</Typography>
      <Stack direction="row" alignItems="center" gap={2}>
        <Button sx={STYLES.button}>
          <img src={editIcon} alt="edit" />
        </Button>
        <Button sx={STYLES.button}>
          <img src={copyIcon} alt="copy" />
        </Button>
        <Button sx={STYLES.button}>
          <img src={deleteIcon} alt="delete" />
        </Button>
      </Stack>
    </Stack>
  );
};
